export default "__VITE_ASSET__9085e2dc__"